import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.107 4.107v3.214h3.214V4.107zm-1.607 0c0-.887.72-1.607 1.607-1.607h3.214c.888 0 1.608.72 1.608 1.607v3.214c0 .888-.72 1.608-1.608 1.608H4.107c-.887 0-1.607-.72-1.607-1.608zm1.607 8.572v3.214h3.214v-3.214zm-1.607 0c0-.888.72-1.608 1.607-1.608h3.214c.888 0 1.608.72 1.608 1.608v3.214c0 .887-.72 1.607-1.608 1.607H4.107c-.887 0-1.607-.72-1.607-1.607zm13.393-8.572h-3.214v3.214h3.214zM12.679 2.5h3.214c.887 0 1.607.72 1.607 1.607v3.214c0 .888-.72 1.608-1.607 1.608h-3.214c-.888 0-1.608-.72-1.608-1.608V4.107c0-.887.72-1.607 1.608-1.607m0 10.179v3.214h3.214v-3.214zm-1.608 0c0-.888.72-1.608 1.608-1.608h3.214c.887 0 1.607.72 1.607 1.608v3.214c0 .887-.72 1.607-1.607 1.607h-3.214c-.888 0-1.608-.72-1.608-1.607z"
    }, null, -1)
  ]))]))
}
export default { render: render }